<template>
  <div class="d-flex justify-content-center">
    <button
      type="button"
      class="btn btn-outline-secondary btn-sm floatend"
      @click="onAddClicked($event)"
    >
      Add {{ name }}
      <i class="bi bi-plus-lg"></i>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AddAsset",
  props: {
    name: { type: String, required: true },
    longName: { type: String, required: true },
    instruction: { type: String, default: "Click Add (+) to add more." }
  },
  emits: ["addClicked"],
  data: function() {
    return {
      selectedValue: "Linked to Inflation"
    };
  },
  methods: {
    onAddClicked(event: any) {
      event.preventDefault();
      this.$emit("addClicked");
    }
  }
});
</script>
